// extracted by mini-css-extract-plugin
export default {"-large":"layout-button-module__-large--Xlr6t","layoutImageContainer":"layout-button-module__layoutImageContainer--R73Dw","layoutImage":"layout-button-module__layoutImage--foTqj"};